import { createReducer, on } from '@ngrx/store';
import * as ProcurementActions from './procurement.actions';
import * as FboLocationsActions from '../../../administration/fbo-locations/fbo-locations.actions';

import { ProcurementListItemDto } from '../../../../api/gse/models/procurement-list-item-dto';

export interface ProcurementState {
  procurements: ProcurementListItemDto[];
  totalRecords: number;
  loading: boolean;
  error: string | null;
  replenishmentSuccessVersion: number;
  replenishmentSubmitting: boolean;
  replenishmentError: string | null;
}

export const initialState: ProcurementState = {
  procurements: [],
  totalRecords: 0,
  loading: false,
  error: null,
  replenishmentSuccessVersion: 0,
  replenishmentSubmitting: false,
  replenishmentError: null,
};

export const procurementReducer = createReducer(
  initialState,
  on(ProcurementActions.createRequisition, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(ProcurementActions.createRequisitionSuccess, (state) => ({
    ...state,
    loading: false,
    error: null,
  })),
  on(ProcurementActions.createRequisitionFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(ProcurementActions.createReplenishment, (state) => ({
    ...state,
    loading: true,
    error: null,
    replenishmentSubmitting: true,
    replenishmentError: null,
  })),
  on(ProcurementActions.createReplenishmentSuccess, (state) => ({
    ...state,
    loading: false,
    error: null,
    replenishmentSuccessVersion: state.replenishmentSuccessVersion + 1,
    replenishmentSubmitting: false,
    replenishmentError: null,
  })),
  on(ProcurementActions.createReplenishmentFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
    replenishmentSubmitting: false,
    replenishmentError: error,
  })),
  on(FboLocationsActions.switchFboLocationSuccess, () => ({
    ...initialState,
    loading: true,
  })),
  on(ProcurementActions.loadProcurements, (state) => ({
    ...state,
    procurements: [],
    totalRecords: 0,
    loading: true,
    error: null,
  })),
  on(ProcurementActions.loadProcurementsSuccess, (state, { response }) => ({
    ...state,
    procurements: response.data || [],
    totalRecords: response.page?.totalElements || 0,
    loading: false,
    error: null,
  })),
  on(ProcurementActions.loadProcurementsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
